@if (data$ | async; as data) {
  @if (products$ | async; as rawProducts$) {
    @if (rawProducts$.length > 0) {
      <div class="carousel-container">
        <aimo-cx-carousel
          class="carousel-products"
          role="region"
          tabindex="-1"
          itemWidth="10px"
          [showAsAccordion]="showAsAccordion"
          [hideIndicators]="true"
          [banner$]="bannerComponent$"
          [items]="rawProducts$"
          [title]="data.title"
          [showAllText]="data.showAllText"
          [showAllUrl]="data.showAllUrl"
          [template]="carouselItem"
          [idSuffix]="data.uid"
          [gtmParams]="gtmParams">
        </aimo-cx-carousel>
      </div>
    }
  }
} @else {
  <aimo-spinner></aimo-spinner>
}

<ng-template #carouselItem let-item="item" let-index="index" let-idSuffix="idSuffix">
  <aimo-product-grid-item
    [product]="item"
    [showComparison]="false"
    [idSuffix]="idSuffix + '_' + index"
    [gtmProductAttributes]="createGtmAttributes(index, item)"
    [openProductPageFromLink]="false">
  </aimo-product-grid-item>
</ng-template>

